export enum EServiceType {
    Air,
    Surface,
    Dialyse,
    Endoscope
}